"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatorOutreachResponse = void 0;
var CreatorOutreachResponse;
(function (CreatorOutreachResponse) {
    let outreachMedium;
    (function (outreachMedium) {
        outreachMedium["DISCORD"] = "discord";
        outreachMedium["EMAIL"] = "email";
    })(outreachMedium = CreatorOutreachResponse.outreachMedium || (CreatorOutreachResponse.outreachMedium = {}));
    let outreachMethod;
    (function (outreachMethod) {
        outreachMethod["AUTOMATIC"] = "automatic";
        outreachMethod["MANUAL"] = "manual";
    })(outreachMethod = CreatorOutreachResponse.outreachMethod || (CreatorOutreachResponse.outreachMethod = {}));
    let outreachTarget;
    (function (outreachTarget) {
        outreachTarget["AGENCY"] = "agency";
        outreachTarget["DIRECT"] = "direct";
    })(outreachTarget = CreatorOutreachResponse.outreachTarget || (CreatorOutreachResponse.outreachTarget = {}));
    let spContractTarget;
    (function (spContractTarget) {
        spContractTarget["AGENCY"] = "agency";
        spContractTarget["DIRECT"] = "direct";
    })(spContractTarget = CreatorOutreachResponse.spContractTarget || (CreatorOutreachResponse.spContractTarget = {}));
    let spStanding;
    (function (spStanding) {
        spStanding["GOOD"] = "good";
        spStanding["UNKNOWN"] = "unknown";
        spStanding["SUSPECTED"] = "suspected";
        spStanding["BANNED"] = "banned";
    })(spStanding = CreatorOutreachResponse.spStanding || (CreatorOutreachResponse.spStanding = {}));
    let paymentTarget;
    (function (paymentTarget) {
        paymentTarget["AGENCY"] = "agency";
        paymentTarget["DIRECT"] = "direct";
    })(paymentTarget = CreatorOutreachResponse.paymentTarget || (CreatorOutreachResponse.paymentTarget = {}));
})(CreatorOutreachResponse = exports.CreatorOutreachResponse || (exports.CreatorOutreachResponse = {}));
